<template lang="pug">
v-row(align="center", justify="center")
  v-row
    v-col(xs="12", sm="12", md="12")
      v-toolbar(color="red", style="margin-top: -12px")
        v-toolbar-title
          span(style="color: #ffffff; font-size: 25px") Formulir Induksi
        v-spacer 
      v-row(align="center", justify="center")
        v-col(
          xs="12",
          sm="12",
          md="12",
          :style="$vuetify.breakpoint.xs ? 'padding:10px 15px 0px 30px' : 'padding:10px 30px 0px 30px'"
        )
          v-stepper(v-model="e1")
            v-stepper-header
              v-stepper-step(:complete="e1 > 1", step="1")
                | Data Personal
              v-divider
              v-stepper-step(:complete="e1 > 2", step="2")
                | Video
              v-divider
              v-stepper-step(:complete="e1 > 3", step="3")
                | Form
              v-divider
              v-stepper-step(:complete="e1 > 4", step="4")
                | Success
            v-stepper-items
              v-stepper-content(step="1")
                v-card(height="auto")
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                    )
                      span(style="font-size: 20px") Data Personal
                  v-layout(row, wrap )
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span Nama Lengkap
                    v-flex(xs7, sm7)
                      p.headerSection 
                        span.mustFill 
                        span {{dataPersonal.name}}
                    v-flex(xs1, sm2)
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span Email
                    v-flex(xs7, sm7)
                      p.headerSection 
                        span.mustFill 
                        span {{dataPersonal.email}}
                    v-flex(xs1, sm2)
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span Nomor Handphone
                    v-flex(xs7, sm7)
                      p.headerSection 
                        span.mustFill 
                        span {{dataPersonal.phone}}
                    v-flex(xs1, sm2)
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span Nomor Darurat
                    v-flex(xs7, sm7)
                      p.headerSection 
                        span.mustFill 
                        span {{dataPersonal.emergencyPhone}}
                    v-flex(xs1, sm2)
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span Golongan Darah
                    v-flex(xs7, sm7)
                      p.headerSection 
                        span.mustFill 
                        span {{dataPersonal.bloodType}}
                    v-flex(xs1, sm2)
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span NIK KTP
                    v-flex(xs7, sm7)
                      p.headerSection 
                        span.mustFill 
                        span {{dataPersonal.ktp}}
                    v-flex(xs1, sm2)
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span KTP
                    v-flex(xs6 sm3 class="attachment" v-if="ktpDoc" style="margin-left:12px")
                      v-btn(tile text @click="downloadKtp(ktpDoc)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal;margin-top:17px" height="auto") 
                        tr
                            td(style="padding-left:1px;" ) 
                                v-icon(small) mdi-attachment
                            td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                            td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                img(src="../assets/check.png" width="10" )
                    v-flex(xs6 sm3 class="attachmentName" v-else style="margin-left:12px")
                        tr
                            td(style="padding-left:1px" ) 
                                v-icon(small) mdi-attachment
                            td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                            td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                img(src="../assets/close.png" width="10" class="verMiddle")
                    v-flex(xs1 sm4)
                    v-flex(xs4, sm3)
                      p.headerSection 
                        span.mustFill 
                        span Alamat
                    v-flex(xs7, sm7)
                      p.headerSection 
                        span.mustFill 
                        span {{dataPersonal.address}}
                    v-flex(xs1, sm2)
                    v-flex(xs4, sm3 v-if="showApd(apdHelm)")
                      p.headerSection 
                        span.mustFill 
                        span APD Helm
                    v-flex(xs7, sm7 v-if="showApd(apdHelm)")
                      p.headerSection 
                        span.mustFill 
                        span {{apdHelm}}
                    v-flex(xs1, sm2 v-if="showApd(apdHelm)")
                    v-flex(xs4, sm3 v-if="showApd(apdRompi)")
                      p.headerSection 
                        span.mustFill 
                        span APD Rompi
                    v-flex(xs7, sm7 v-if="showApd(apdRompi)")
                      p.headerSection 
                        span.mustFill 
                        span {{apdRompi}}
                    v-flex(xs1, sm2 v-if="showApd(apdRompi)")
                    v-flex(xs4, sm3 v-if="showApd(apdSepatu)")
                      p.headerSection 
                        span.mustFill 
                        span APD Sepatu
                    v-flex(xs7, sm7 v-if="showApd(apdSepatu)")
                      p.headerSection 
                        span.mustFill 
                        span {{apdSepatu}}
                    v-flex(xs1, sm2 v-if="showApd(apdSepatu)")
                    v-flex(xs12, sm2 style="margin-left:12px;margin-bottom:40px;margin-top:50px")
                      v-btn(color='primary' style="width:97%"  @click="e1 = 2; scrollTop()", :disabled="dataPersonal.overallStatus < 4 ? true : false")  Continue 
              v-stepper-content(step="2")
                v-card(height="auto")
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                      style="text-align: center"
                    )
                      span(style="font-size: 20px") Video Induksi PT.Borneo Indobara
                      br
                      p(style="color: red") *
                        span(style="color: black") Tonton video Induksi dari PT. Borneo Indobara sampai selesai sebelum mengisi formulir
                  v-row(
                    align="center",
                    justify="center",
                    :class="{ 'costum-margin': $vuetify.breakpoint.xs }"
                  )
                    v-col(xs="12", sm="12", md="12")
                      video#video(
                        controls="",
                        width="100%",
                        height="420",
                        style="pointer-events: none"
                      )
                        source(
                          src="https://storage.googleapis.com/ipermit-data/video/M%20-%20Video%20Induksi%20Tamu_Subtitle%202021%20-%20REENCODED.mp4",
                          type="video/mp4"
                        )
                        object(
                          type="application/x-shockwave-flash",
                          data="player.swf",
                          width="640",
                          height="360"
                        )
                          param(name="movie", value="player.swf")
                          param(
                            name="flashvars",
                            value="autostart=true&controlbar=over&image=poster.jpg&file=http://clips.vorwaerts-gmbh.de/VfE_flash.mp4"
                          )
                          img(
                            src="poster.jpg",
                            alt="Induksi Video",
                            title="No video playback capabilities, please download the video below",
                            width="640",
                            height="360"
                          )
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                      style="text-align: center"
                    )
                      v-btn(color="success", @click="playVid")
                        | Play
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                      style="text-align: center"
                    )
                      v-btn(
                        color="primary",
                        @click="e1 = 3; scrollTop()",
                        :disabled="!videoComplete"
                      )
                        | Isi Form induksi
              v-stepper-content(step="3")
                v-card.mb-12(height="auto", style="padding: 20px")
                  v-layout(row, wrap)
                    v-flex(xs12, sm12) 
                      h2 Daftar Pertanyaan Induksi
                      br
                      v-divider
                      h3(style="color: red") *
                        span.font-italic(style="color: ") Silahkan beri tanda
                        span ☑️
                        span.font-italic jika telah memahami (Wajib di isi semua) / Please mark
                        span ☑️
                        span.font-italic if you have understood (Mandatory in all contents)
                    v-flex
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[0]"
                      )
                    v-flex(xs7, sm10)
                      p Rencana kunjungan (Tamu) sudah diterima oleh pihak perusahaan dan disetujui oleh KTT
                        br
                        span.font-italic Permit from Technical Mine Manager (KTT)
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[1]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus menukarkan kartu identitas pribadi di pos keamanan untuk mendapat kartu tamu (Visitor) yang akan digunakan selama kunjungan
                        br
                        span.font-italic You shall left ID Card to Security and get ID visitor must use at all times.
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[2]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus dalam keadaan sehat untuk melakukan kunjungan (Istirahat yang cukup)
                        br
                        span.font-italic You must be fit to work
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[3]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung wajib didampingi oleh perwakilan perusahaan/departemen kustodian selama kunjungan berlangsung
                        br
                        span.font-italic You must be escorted by an appointed company's representative all times
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[4]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus mematuhi semua instruksi keselamatan yang telah diberikan oleh perwakilan perusahaan
                        br
                        span.font-italic You must obey all safety instruction
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[5]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus menggunakan semua APD alat pelindung diri yang dipersyaratkan untuk suatu area kerja
                        br
                        span.font-italic You must be wearing all protective personal equipment as required
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[6]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung tidak diizinkan melakukan kegiatan fisik selain observasi, audit dan pengambilan data
                        br
                        span.font-italic No physical activity except observation, audit and data collection
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[7]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung tidak diizinkan mengoperasikan kendaraan/unit apapun kecuali telah mengikuti induksi/test khusus
                        br
                        span.font-italic Do not operate vehicle or unit without authority
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[8]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus menjaga diri agar tidak membuang sampah selain pada tempat yang telah disiapkan
                        br
                        span.font-italic Do not litter
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[9]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus menjaga diri untuk tidak merokok atau membuat api pada daerah yang ditetapkan
                        br
                        span.font-italic Obey no smoking and no fire area.
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[10]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus segera melaporkan adanya bahaya atau insiden kepada pendampingnya atau ke HSE Centre
                        br
                        span.font-italic Report any hazard and incident to your escorter or the HSE Call Centre
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[11]"
                      )
                    v-flex(xs7, sm10)
                      p Pengunjung harus segera evakuasi diri ke titik kumpul darurat jika terjadi keadaan darurat dalam kunjungan
                        br
                        span.font-italic Evacuate yourself to the muster point when emergency
                        v-divider
                    v-flex(xs1, sm1)

                    v-flex(xs4, sm1)
                      v-checkbox(
                        style="margin-top: 0",
                        v-model="inductionAnswers[12]"
                      )
                    v-flex(xs7, sm10)
                      p Simpan nomor HSE Centre 0812 5109 555 untuk melaporkan bahaya, insiden atau situasi darurat. (Sebutkan DARURAT 3x Nama & Lokasi)
                        br
                        span.font-italic Keep the Emergency call centre's number 0812 5109 555 while you are inside PT. Borneo Indobara work area. Say "EMERGENCY" 3x followed by your Name & Location, to get immediate help
                        v-divider
                    v-flex(xs1, sm1)
                v-btn(text, @click="e1 = 1", v-if="!$vuetify.breakpoint.xs") Back
                v-btn(
                  color="primary",
                  @click="submit(7)",
                  :disabled="!isPage2Complete",
                  v-if="!$vuetify.breakpoint.xs"
                ) Submit
                v-flex(v-else)
                  v-col
                    v-btn(
                      color="primary",
                      @click="submit(7)",
                      :disabled="!isPage2Complete",
                      block
                    ) Submit
              //- :disabled='!isPage2Complete'
              v-stepper-content(step="4")
                v-card(height="66vh")
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                      style="text-align: center"
                    )
                      v-icon(color="blue", large) mdi-check-circle
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                      style="text-align: center"
                    )
                      span(style="font-size: 20px") {{ this.submitedText }}
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                      style="text-align: center; margin-top: -20px"
                    )
                      span(style="font-size: 20px") Data anda telah berhasil disimpan
                  v-row(align="center", justify="center")
                    v-col(
                      xs="12",
                      sm="12",
                      md="12",
                      style="text-align: center; margin-top: -20px"
                    )
                      span(style="font-size: 14px") Silahkan tutup halaman ini
</template>

<script>
import helper from "../helper/index.js";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "FormInduction",
  props: ["dataVisitor", "ipForm", "visitorToken","visitorInfo"],
  data() {
    return {
      e1: 1,
      inductionAnswers: Array.from({ length: 13 }, () => false),

      skip: [],
      ended: false,
      uploadId: null,
      docPendukung: null,
      submitedText: "",
      submitClick: false,
      dataPersonal:{},
      ktpDoc :"",
      apdHelm:"",
      apdSepatu:"",
      apdRompi:"",
      rules: [
        (value) =>
          !value || value.size < 10000000 || "Ukuran file harus dibawah 10 MB!",
      ],
      emptyUpload: new File([""], "", {
        type: "",
      }),
    };
  },
  mounted: async function () {
    this.$store.dispatch("fetchLocations");
    this.uploadId = Date.now();
    this.visitorId = this.visitorToken.idVisitor;

    const $video = document.querySelector("video");

    const onTimeUpdate = (event) => {
      console.log(checkSkipped(event.target.currentTime));
    };

    let prevTime = 0;
    const checkSkipped = (currentTime) => {
      const skipThreshold = 2;

      // user skipped any part of the video
      if (currentTime - prevTime > skipThreshold) {
        this.skip.push({
          periodSkipped: currentTime - prevTime,
          startAt: prevTime,
          endAt: currentTime,
        });
        prevTime = currentTime;
        return this.skip;
      }

      prevTime = currentTime;
      return false;
    };

    $video.addEventListener("timeupdate", onTimeUpdate);

    $video.addEventListener("ended", () => {
      this.ended = true;
    });
  },
  computed: {
    ...mapState(["API_URL", "locations", "dataUsers", "dataEditRequest"]),
    selectedLoc() {
      let tempLoc = [];
      let locationCode;

      if (this.dataUsers.location instanceof Array) {
        locationCode = this.dataUsers.location[0];
      } else {
        locationCode = this.dataUsers.location;
      }

      for (let i = 0; i < this.lokasi.length; i++) {
        tempLoc.push({ code: locationCode, name: this.lokasi[i] });
      }
      return tempLoc;
    },
    videoComplete() {
      return this.ended && this.skip.length == 0;
    },
    isPage2Complete: function () {
      return this.inductionAnswers.every((ans) => ans); // Only true if all answer are true
    },
  },
  methods: {
    playVid() {
      const vid = document.querySelector("video");

      vid.play();
    },
    showApd(param){
      return param !== ""
    },
    downloadKtp(file) {
      if ( this.dataPersonal.ktpImage.docPendukung ) {
          this.$downloadFile(file);
      } else {
          window.open(file, '_blank');
      }
    },
    pauseVid() {
      const vid = document.querySelector("video");

      vid.pause();
    },
    updatePemegangIzin(user) {
      this.pemegangIzin = user;
    },
    clearDate() {
      this.endDate = null;
      this.startMenu = false;
    },
    formatDate: helper.formatDate,
    scrollTop() {
      window.scrollTo(0, 0);
    },
    closeModal(params) {
      this.openModalNotif = params;
    },
    handleOpenModal() {
      this.openModalNotif = true;
    },
    async submit() {
      this.submitClick = true;
      try {
        const result = await axios.post(
          `${this.API_URL}/v1/requests/submitInduction`,
          {
            inductionAnswers: this.inductionAnswers,
          },
          {
            headers: {
              Authorization: `Bearer ${this.visitorToken.token}`,
            },
          }
        );
        if (result.data.data == "Done") this.e1 = 4;
      } catch (error) {
        console.log(error.response.data);

        this.$store.state.loader = false;
        this.$snackbar.showMessage({ message: "Gagal mengirim data induksi. Silakan hubungi Admin STC.", color: 'red' });
      }
    },
    deleteDocPendukung(name) {
      let id = this.visitorKtpUploadId.toString();
      axios
        .post(`${this.API_URL}/v1/requests/deleteFileGCS`, 
        {
          uploadId: id,
          folderName: name
        },
        {
          headers: { Authorization: `Bearer ${this.visitorToken.token}` },
        })
        .then(() => {
          this.docPendukung = null;
        })
        .catch(() => {
          this.$snackbar.showMessage({ message: "Delete failed!", color: 'red' });
        });
    },
    backHome() {
      this.$router.push("/my-permit");
    },
    backStep() {
      this.e1--;
    },
    docName(name) {
      return this.$setFilename(name);
    },
  },
  watch: {
    docPendukung(params) {
      if (params && params.size < 10000000) {
        let formData = new FormData();
        this.visitorKtpUploadId = Date.now();
        formData.append("uploadId", this.visitorKtpUploadId);
        formData.append("docPendukung", params);
        axios.post(
          `${this.API_URL}/v1/requests/attachment/docPendukung`,
          formData,
          { headers: { Authorization: `Bearer ${this.visitorToken.token}` } }
        );
      }
    },
    visitorInfo(param){
      // console.log(param)
      this.dataPersonal = param
      this.ktpDoc = param.ktpImage.docPendukung ? param.ktpImage.docPendukung : param.ktpImage.docPendukungUrl
      this.apdHelm = param.apd.helm
      this.apdSepatu = param.apd.sepatu
      this.apdRompi = param.apd.rompi
    }
  },
};
</script>

<style>
.ck-editor__editable {
  min-height: 300px;
  max-height: 300px;
  resize: none;
}
.mustFill {
  color: #ea5164;
}
</style>
